import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API || "https://www.vilaro.ro/api";

const card = {
  background: "rgba(255,255,255,0.03)",
  border: "1px solid rgba(255,255,255,0.08)",
};

const inputStyle = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.1)",
  color: "white",
  outline: "none",
};

const btnPrimary = { background: "linear-gradient(135deg, #6366f1, #8b5cf6)", color: "white" };
const btnGray = { background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.7)" };
const btnGreen = { background: "rgba(34,197,94,0.15)", border: "1px solid rgba(34,197,94,0.3)", color: "#86efac" };

const toneOptions = [
  { id: "sustinere", label: "🟢 Susținere", desc: "Suportiv, argument personal" },
  { id: "contra", label: "🟡 Contra-argument", desc: "Politicos, dezacord nuanțat" },
  { id: "intrebare", label: "🔵 Întrebare", desc: "Stimulează discuția" },
  { id: "neutru", label: "⚪ Neutru", desc: "Informativ, neutral" },
];

export default function Reactions() {
  const [identities, setIdentities] = useState([]);
  const [identityId, setIdentityId] = useState("");
  const [url, setUrl] = useState("");
  const [actionType, setActionType] = useState("like"); // like | comment
  const [commentText, setCommentText] = useState("");
  const [aiTone, setAiTone] = useState("sustinere");
  const [postPreview, setPostPreview] = useState("");
  const [loading, setLoading] = useState(false);
  const [aiLoading, setAiLoading] = useState(false);
  const [message, setMessage] = useState(null); // {type, text}
  const [actionsLog, setActionsLog] = useState([]);

  useEffect(() => {
    fetchIdentities();
    fetchActionsLog();
  }, []);

  const fetchIdentities = async () => {
    try {
      const res = await axios.get(`${API}/playwright/identities`);
      const active = (res.data.identities || []).filter(i => i.health_status === "active" || i.health_status === "expiring");
      setIdentities(active);
      if (active.length > 0 && !identityId) setIdentityId(active[0].id);
    } catch (e) { console.error(e); }
  };

  const fetchActionsLog = async () => {
    try {
      const res = await axios.get(`${API}/playwright/actions/log?limit=15`);
      setActionsLog(res.data.actions || []);
    } catch (e) { console.error(e); }
  };

  const generateAI = async () => {
    if (!url.trim() || !identityId) {
      setMessage({ type: "error", text: "Introdu URL postare și selectează identitate" });
      return;
    }
    setAiLoading(true);
    setMessage(null);
    setPostPreview("");
    try {
      const res = await axios.post(`${API}/playwright/generate-comment`, {
        post_url: url, identity_id: identityId, tone: aiTone
      }, { timeout: 90000 });
      if (res.data.success) {
        setCommentText(res.data.comment || "");
        setPostPreview(res.data.post_preview || "");
        setMessage({ type: "success", text: "✨ Comentariu generat AI" });
      } else {
        setMessage({ type: "error", text: "Eroare AI: " + (res.data.error || "necunoscut") });
      }
    } catch (e) {
      setMessage({ type: "error", text: "Eroare: " + (e.response?.data?.detail || e.message) });
    } finally {
      setAiLoading(false);
    }
  };

  const execute = async () => {
    if (!url.trim() || !identityId) {
      setMessage({ type: "error", text: "Introdu URL postare și selectează identitate" });
      return;
    }
    if (actionType === "comment" && !commentText.trim()) {
      setMessage({ type: "error", text: "Introdu textul comentariului" });
      return;
    }

    setLoading(true);
    setMessage(null);
    try {
      const endpoint = actionType === "like" ? "/playwright/like" : "/playwright/comment";
      const payload = { identity_id: identityId, post_url: url };
      if (actionType === "comment") payload.text = commentText;

      const res = await axios.post(`${API}${endpoint}`, payload, { timeout: 120000 });
      if (res.data.success) {
        setMessage({ type: "success", text: `✅ ${actionType === "like" ? "Like" : "Comentariu"} aplicat cu succes` });
        if (actionType === "comment") setCommentText("");
        await fetchActionsLog();
        await fetchIdentities();
      } else {
        setMessage({ type: "error", text: "❌ " + (res.data.error || "Eroare necunoscută") });
      }
    } catch (e) {
      setMessage({ type: "error", text: "Eroare: " + (e.response?.data?.detail || e.message) });
    } finally {
      setLoading(false);
    }
  };

  const selectedIdent = identities.find(i => i.id === identityId);

  return (
    <div className="space-y-5">
      <div>
        <h2 className="text-2xl font-bold text-white mb-1">⚔️ Reacții pe postări externe</h2>
        <p className="text-sm" style={{ color: "rgba(255,255,255,0.4)" }}>
          Acționează pe orice postare publică Facebook cu identitățile tale (Like, Comentariu).
        </p>
      </div>

      {identities.length === 0 ? (
        <div className="rounded-2xl p-6 text-center" style={card}>
          <p className="text-sm" style={{ color: "rgba(255,255,255,0.6)" }}>
            Niciun identitate Playwright activă. Mergi la <strong>Configurare → Playwright</strong> pentru a activa.
          </p>
        </div>
      ) : (
        <>
          {/* Card acțiune */}
          <div className="rounded-2xl p-6" style={card}>
            <h3 className="font-semibold text-white mb-4">🎯 Acțiune nouă</h3>

            <div className="space-y-4">
              {/* URL */}
              <div>
                <label className="text-xs mb-1 block" style={{ color: "rgba(255,255,255,0.4)" }}>URL postare Facebook</label>
                <input
                  type="text"
                  className="w-full rounded-xl px-3 py-2.5 text-sm font-mono"
                  style={inputStyle}
                  placeholder="https://www.facebook.com/.../posts/..."
                  value={url}
                  onChange={e => setUrl(e.target.value)}
                />
              </div>

              {/* Identitate */}
              <div>
                <label className="text-xs mb-1 block" style={{ color: "rgba(255,255,255,0.4)" }}>Acționează cu identitatea</label>
                <select
                  className="w-full rounded-xl px-3 py-2.5 text-sm"
                  style={inputStyle}
                  value={identityId}
                  onChange={e => setIdentityId(Number(e.target.value))}
                >
                  {identities.map(i => (
                    <option key={i.id} value={i.id} style={{ background: "#0f0f1a" }}>
                      {i.type === "account" ? "👤" : "📄"} {i.name} ({i.actions_today}/{i.daily_limit} azi)
                    </option>
                  ))}
                </select>
                {selectedIdent && selectedIdent.remaining <= 0 && (
                  <p className="text-xs mt-1" style={{ color: "#fca5a5" }}>
                    ⚠️ Limită zilnică atinsă pentru această identitate
                  </p>
                )}
              </div>

              {/* Tab actiune Like / Comment */}
              <div className="flex gap-2">
                <button
                  onClick={() => setActionType("like")}
                  className="px-4 py-2 rounded-xl text-sm font-medium flex-1"
                  style={actionType === "like" ? btnPrimary : btnGray}
                >
                  👍 Like
                </button>
                <button
                  onClick={() => setActionType("comment")}
                  className="px-4 py-2 rounded-xl text-sm font-medium flex-1"
                  style={actionType === "comment" ? btnPrimary : btnGray}
                >
                  💬 Comentariu
                </button>
              </div>

              {/* Form Comment */}
              {actionType === "comment" && (
                <div className="space-y-3">
                  <div>
                    <label className="text-xs mb-1 block" style={{ color: "rgba(255,255,255,0.4)" }}>Ton AI</label>
                    <div className="grid grid-cols-2 gap-2">
                      {toneOptions.map(t => (
                        <button
                          key={t.id}
                          onClick={() => setAiTone(t.id)}
                          className="px-3 py-2 rounded-xl text-xs text-left"
                          style={aiTone === t.id ?
                            { background: "rgba(99,102,241,0.15)", border: "1px solid rgba(99,102,241,0.4)", color: "#a5b4fc" } :
                            { background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", color: "rgba(255,255,255,0.6)" }
                          }
                        >
                          <div className="font-medium">{t.label}</div>
                          <div className="text-xs opacity-60">{t.desc}</div>
                        </button>
                      ))}
                    </div>
                  </div>

                  <div>
                    <div className="flex justify-between items-center mb-1">
                      <label className="text-xs" style={{ color: "rgba(255,255,255,0.4)" }}>Text comentariu</label>
                      <button
                        onClick={generateAI}
                        disabled={aiLoading || !url.trim()}
                        className="px-3 py-1 rounded-lg text-xs font-medium disabled:opacity-50"
                        style={btnGreen}
                      >
                        {aiLoading ? "⏳ Citesc postarea..." : "✨ Generează cu AI"}
                      </button>
                    </div>
                    <textarea
                      className="w-full rounded-xl px-3 py-2.5 text-sm resize-y"
                      style={inputStyle}
                      rows={4}
                      placeholder="Sau scrie manual..."
                      value={commentText}
                      onChange={e => setCommentText(e.target.value)}
                    />
                    <div className="text-xs mt-1" style={{ color: "rgba(255,255,255,0.3)" }}>
                      {commentText.length} caractere, {commentText.trim().split(/\s+/).filter(Boolean).length} cuvinte
                    </div>
                  </div>

                  {postPreview && (
                    <div className="rounded-xl p-3" style={{ background: "rgba(99,102,241,0.08)", border: "1px solid rgba(99,102,241,0.2)" }}>
                      <div className="text-xs mb-1" style={{ color: "rgba(255,255,255,0.4)" }}>📄 Postarea citită de AI:</div>
                      <div className="text-xs" style={{ color: "rgba(255,255,255,0.7)" }}>{postPreview}...</div>
                    </div>
                  )}
                </div>
              )}

              {/* Mesaj */}
              {message && (
                <div className="rounded-xl p-3 text-sm" style={{
                  background: message.type === "success" ? "rgba(34,197,94,0.1)" : "rgba(239,68,68,0.1)",
                  border: "1px solid " + (message.type === "success" ? "rgba(34,197,94,0.3)" : "rgba(239,68,68,0.3)"),
                  color: message.type === "success" ? "#86efac" : "#fca5a5"
                }}>
                  {message.text}
                </div>
              )}

              {/* Buton execută */}
              <button
                onClick={execute}
                disabled={loading || !url.trim() || (actionType === "comment" && !commentText.trim())}
                className="w-full px-4 py-3 rounded-xl text-sm font-semibold disabled:opacity-50"
                style={btnPrimary}
              >
                {loading ? "⏳ Se execută..." :
                 actionType === "like" ? "👍 Pune Like" : "💬 Postează comentariul"}
              </button>
            </div>
          </div>

          {/* Istoric acțiuni */}
          <div className="rounded-2xl p-6" style={card}>
            <div className="flex justify-between items-center mb-3">
              <h3 className="font-semibold text-white">📋 Istoric acțiuni</h3>
              <button onClick={fetchActionsLog} className="px-2 py-1 rounded-lg text-xs" style={btnGray}>🔄</button>
            </div>
            {actionsLog.length === 0 ? (
              <p className="text-sm text-center py-6" style={{ color: "rgba(255,255,255,0.3)" }}>
                Niciun istoric încă
              </p>
            ) : (
              <div className="space-y-2">
                {actionsLog.map(a => (
                  <div key={a.id} className="rounded-xl p-3 flex items-start justify-between gap-3" style={{ background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.05)" }}>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-xs">{a.action_type === "like" ? "👍" : "💬"}</span>
                        <span className="text-sm font-medium text-white">{a.identity_name}</span>
                        <span className="text-xs px-1.5 py-0.5 rounded" style={{
                          background: a.success ? "rgba(34,197,94,0.15)" : "rgba(239,68,68,0.15)",
                          color: a.success ? "#86efac" : "#fca5a5"
                        }}>
                          {a.success ? "✓" : "✗"}
                        </span>
                      </div>
                      <a href={a.post_url} target="_blank" rel="noreferrer" className="text-xs truncate block" style={{ color: "rgba(255,255,255,0.4)" }}>
                        {a.post_url.length > 80 ? a.post_url.substring(0, 80) + "..." : a.post_url}
                      </a>
                      {a.text_content && (
                        <div className="text-xs mt-1 italic" style={{ color: "rgba(255,255,255,0.5)" }}>
                          "{a.text_content.substring(0, 100)}{a.text_content.length > 100 ? "..." : ""}"
                        </div>
                      )}
                      {a.error && (
                        <div className="text-xs mt-1" style={{ color: "#fca5a5" }}>
                          ❌ {a.error.substring(0, 120)}
                        </div>
                      )}
                    </div>
                    <div className="text-xs whitespace-nowrap" style={{ color: "rgba(255,255,255,0.3)" }}>
                      {new Date(a.created_at + "Z").toLocaleString("ro-RO", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" })}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
